import { apiClient } from "../api/ApiClient";

export function getAllDistinctCategoriesWithCollectionName(collections = []) {
  if (!Array.isArray(collections) || collections.length === 0) {
    return [];
  }

  const result = [];

  collections.forEach(collection => {
    const collectionName = collection.name;
    
    // Add parent categories from this collection
    if (Array.isArray(collection.categories)) {
      collection.categories.forEach(category => {
        // Add the main category
        result.push({
          id: category.id,
          name: category.name,
          name_url: category.name_url,
          image_url: category.image_url,
          collection: collectionName,
        });
      });
    }
  });

  return result;
}


export const setLanguage = (lang) => {
  if (lang) {
    localStorage.setItem("lang", lang);
    apiClient.defaults.headers.common["Accept-Language"] = lang;
  }
};

// get current language
export const getLanguage = () => {
  return localStorage.getItem("lang") || "EN";
};


// Helper.js
export const egyptGovernorates = [
  { id: 1, name: { EN: 'Cairo', AR: 'القاهرة' } },
  { id: 2, name: { EN: 'Giza', AR: 'الجيزة' } },
  { id: 3, name: { EN: 'Alexandria', AR: 'الإسكندرية' } },
  { id: 4, name: { EN: 'Dakahlia', AR: 'الدقهلية' } },
  { id: 5, name: { EN: 'Red Sea', AR: 'البحر الأحمر' } },
  { id: 6, name: { EN: 'Beheira', AR: 'البحيرة' } },
  { id: 7, name: { EN: 'Fayoum', AR: 'الفيوم' } },
  { id: 8, name: { EN: 'Gharbia', AR: 'الغربية' } },
  { id: 9, name: { EN: 'Ismailia', AR: 'الإسماعيلية' } },
  { id: 10, name: { EN: 'Menofia', AR: 'المنوفية' } },
  { id: 11, name: { EN: 'Minya', AR: 'المنيا' } },
  { id: 12, name: { EN: 'Qaliubiya', AR: 'القليوبية' } },
  { id: 13, name: { EN: 'New Valley', AR: 'الوادي الجديد' } },
  { id: 14, name: { EN: 'Suez', AR: 'السويس' } },
  { id: 15, name: { EN: 'South Sinai', AR: 'جنوب سيناء' } },
  { id: 16, name: { EN: 'Aswan', AR: 'أسوان' } },
  { id: 17, name: { EN: 'Assiut', AR: 'أسيوط' } },
  { id: 18, name: { EN: 'Beni Suef', AR: 'بني سويف' } },
  { id: 19, name: { EN: 'Port Said', AR: 'بورسعيد' } },
  { id: 20, name: { EN: 'Damietta', AR: 'دمياط' } },
  { id: 21, name: { EN: 'Sharkia', AR: 'الشرقية' } },
  { id: 22, name: { EN: 'Sohag', AR: 'سوهاج' } },
  { id: 23, name: { EN: 'Qena', AR: 'قنا' } },
  { id: 24, name: { EN: 'Kafr El Sheikh', AR: 'كفر الشيخ' } },
  { id: 25, name: { EN: 'Matrouh', AR: 'مطروح' } },
  { id: 26, name: { EN: 'Luxor', AR: 'الأقصر' } },
  { id: 27, name: { EN: 'Qalyubia', AR: 'القليوبية' } },
  { id: 28, name: { EN: 'North Sinai', AR: 'شمال سيناء' } }
];

export const getGovernorateName = (lang, governorate) => {
  return governorate.name[lang] || governorate.name.AR;
};